import React from 'react';

// Teamatical's logo as an outline, drawn to sit at the same visual size as
// the Polaris icons around it. Inline fill wins over uh.css's
// `.uh-icon svg { fill: currentColor }`.
export default function TeamaticalIcon(props) {
  return (
    <svg viewBox="-217 -225 3400 3400" aria-hidden="true" focusable="false" {...props}
      style={{ fill: 'none', stroke: 'currentColor', strokeWidth: 230, strokeLinejoin: 'round', strokeLinecap: 'round' }}>
      <path d="M1889 1688l0 905c0,27 -22,49 -50,49l-711 0c-28,0 -50,-22 -50,-49l0 -904c0,-44 53,-66 84,-35l286 277c19,19 49,19 69,0l288 -278c31,-31 84,-8 84,35z" />
      <path d="M2663 309l-16 0c-776,0 -1551,0 -2326,0l-17 0c-28,0 -50,22 -50,50l0 38c0,137 0,274 0,411l0 38c0,27 22,49 50,49l477 0c204,0 345,53 660,466 21,27 62,28 83,1 331,-423 458,-467 659,-467l480 0c27,0 50,-22 50,-49l0 -38c0,-137 0,-274 0,-411l0 -38c0,-28 -23,-50 -50,-50z" />
    </svg>
  );
}
